$(document).ready(function (e) {

    let $body = $('body');

    // Fit the board to the viewport from where it actually starts, so its horizontal scrollbar
    // stays visible without scrolling the page
    function sizeKanban() {
        let $kanban = $('.kanban'),
            remaining_height = $(window).height() - $kanban.offset().top - parseInt($kanban.css('margin-bottom'), 10);

        remaining_height = Math.max(remaining_height, 300);

        $kanban.css({'height': remaining_height + 'px'});
        $kanban.find('.category').css({'height': remaining_height + 'px'});
        $kanban.find('.records').css({'height': remaining_height + 'px'});
    }

    if ($('.kanban').length) {
        sizeKanban();
        $(window).on('resize', sizeKanban);
    }

    $body.on('click', '.cancel-kanban-save', function (e) {
        let table_id = $(this).data('table-id');
        window.location = `/browse/${table_id}`;
    });

    $body.on('click', '.save-kanban', function (e) {
        let table_id = $(this).data('table-id'),
            error = false,
            payload = [],
            columns = [],
            view_name = $('#view-name').val(),
            categorize_by = $('#categorize-by').val(),
            aggregate_by = $('#aggregate-by').val(),
            $selected_columns = $('.selected-columns').find('.column'),
            colorize = $('input[name="colorize"]:checked').val();

        console.log(colorize);

        $selected_columns.each((i, $column) => {
            columns.push($($column).data('field-id'));
        });

        if (!view_name.length) {
            alert('Please enter view name');
            return;
        }

        if (!categorize_by.length) {
            alert('Select categorize by field');
            return;
        }
        //
        // if (!aggregate_by.length) {
        //     alert('Select aggregate by field');
        //     return;
        // }

        if (!$selected_columns.length) {
            alert('Select columns for filter');
            return;
        }

        if (!error) {
            $.ajax({
                method: 'POST',
                url: `/kanban/${table_id}`,
                data: {
                    payload: payload,
                    title: view_name,
                    columns: columns,
                    aggregate_by: aggregate_by,
                    categorize_by: categorize_by,
                    colorize: colorize
                },
                success: function (res) {
                    if (res) {
                        window.location = `/browse/${table_id}/kanban`;
                    }
                }
            })
        }
    });

    $body.on('click', '.update-kanban', function (e) {
        let table_id = $(this).data('table-id'),
            id = $(this).data('id'),
            error = false,
            payload = [],
            columns = [],
            view_name = $('#view-name').val(),
            categorize_by = $('#categorize-by').val(),
            aggregate_by = $('#aggregate-by').val(),
            $selected_columns = $('.selected-columns').find('.column'),
            colorize = $('input[name="colorize"]:checked').val();


        $selected_columns.each((i, $column) => {
            columns.push($($column).data('field-id'));
        });

        if (!view_name.length) {
            alert('Please enter view name');
            return;
        }

        if (!categorize_by.length) {
            alert('Select categorize by field');
            return;
        }

        // if (!aggregate_by.length) {
        //     alert('Select aggregate by field');
        //     return;
        // }

        if (!$selected_columns.length) {
            alert('Select columns for filter');
            return;
        }

        if (!error) {
            $.ajax({
                method: 'POST',
                url: `/kanban/${table_id}/update`,
                data: {
                    id: id,
                    payload: payload,
                    title: view_name,
                    columns: columns,
                    aggregate_by: aggregate_by,
                    categorize_by: categorize_by,
                    colorize: colorize
                },
                success: function (res) {
                    if (res) {
                        window.location = `/browse/${table_id}/kanban`;
                    }
                }
            })
        }
    });

    let $prevCategoryAggregate,
        kanbanSearch = '',
        kanbanSearchAll = 'no',
        kanbanPageSize = 10;

    $('.kanban .category').each(function (index, $category) {
        loadKanbanRecords($($category));
    });

    $('.kanban .category .records').on('scroll', function (e) {
        let $category = $(this).parents('.category');
        if ($(this).scrollTop() + $(this).innerHeight() + 50 >= $(this)[0].scrollHeight) {
            loadKanbanRecords($($category));
        }
    });

    // Triggered by the navbar search (search.js): reload every column with the search applied
    $(document).on('kanban:search', function (e, search, search_all) {
        if (search === kanbanSearch && search_all === kanbanSearchAll) {
            return;
        }

        kanbanSearch = search;
        kanbanSearchAll = search_all;

        $('.kanban .category').each(function (index, $category) {
            loadKanbanRecords($($category), true);
        });
    });

    // Column header total for the current search, same query as the column's records
    function refreshKanbanAggregate($category) {
        let search = kanbanSearch,
            search_all = kanbanSearchAll;

        $.ajax({
            type: 'GET',
            url: '/lazy-kanban/' + $category.parents('.kanban').attr('data-table') + '/kanban' + window.location.search,
            data: {
                category: $category.attr('data-category'),
                search: search,
                search_all: search_all,
                with_aggregate: 1,
                aggregate_only: 1
            },
            success: function (res) {
                // Search changed meanwhile, the column reload already set the right total
                if (search !== kanbanSearch || search_all !== kanbanSearchAll) {
                    return;
                }

                if (res && res.aggregate !== null) {
                    $category.find('.aggregate-value').text(res.aggregate);
                }
            }
        });
    }

    function loadKanbanRecords($category, reset) {
        if (reset) {
            let pending = $category.data('kanban-request');
            if (pending) {
                pending.abort();
            }
            $category.removeClass('is-loading is-loaded').find('.records').empty();
        }

        var query = window.location.search,
            table_id = $($category).parents('.kanban').attr('data-table'),
            category = $($category).attr('data-category'),
            skip = $($category).find('.records').find('.record').length,
            data = {
                category,
                skip
            };

        if (kanbanSearch.length) {
            data.search = kanbanSearch;
            data.search_all = kanbanSearchAll;
        }

        if (reset) {
            data.with_aggregate = 1;
        }

        if(!$category.hasClass('is-loading') && !$category.hasClass('is-loaded')){

            $category.addClass('is-loading');

            let request = $.ajax({
                type: 'GET',
                url: '/lazy-kanban/' + table_id + '/kanban' + query,
                data: data,
                success: function (res) {
                    if (res) {
                        let $records = $($.parseHTML(res.records || '')).filter('.record');

                        if (res.aggregate !== null) {
                            $category.find('.aggregate-value').text(res.aggregate);
                        }

                        // Last page of this column reached, stop lazy loading on scroll
                        if ($records.length < kanbanPageSize) {
                            $category.addClass('is-loaded');
                        }

                        $($category).find('.records').append($records);

                        $(".record").draggable({
                            revert: "invalid",
                            containment: "document",
                            cursor: "move",
                            helper: "clone",
                            zIndex: 1000,
                            start: function (event, ui) {
                                $prevCategoryAggregate = $(ui.helper).parents('.category').find('.aggregate-value');
                            },
                        });

                        $('.records').droppable({
                            accept: ".record",
                            greedy: true,
                            drop: function (event, ui) {

                                console.log(event);

                                let categorize_field = $(this).attr('data-categorize-field'),
                                    category = $(this).attr('data-category'),
                                    table_id = $('.kanban').attr('data-table'),
                                    kanban_id = $('.kanban').attr('data-kanban'),
                                    record = $(ui.draggable).attr('data-id'),
                                    option_field = $(ui.draggable).find('.cat-by');

                                if (option_field.length) {
                                    let options = JSON.parse($(option_field).attr('data-values')),
                                        colors = JSON.parse($(option_field).attr('data-colors')),
                                        color = colors[options.indexOf(category)];

                                    $(option_field).find('span').css('background-color', color);
                                    $(option_field).find('span').text(category);
                                }


                                $(this).append(ui.draggable.removeAttr('style'));

                                $.ajax({
                                    type: 'POST',
                                    url: '/kanban/category',
                                    data: {
                                        record,
                                        categorize_field,
                                        category,
                                        table_id,
                                        kanban_id
                                    },
                                    success: (res) => {
                                        // Search active: res holds unsearched totals, recalc both columns with the search
                                        if (kanbanSearch.length) {
                                            refreshKanbanAggregate($(this).parents('.category'));
                                            refreshKanbanAggregate($($prevCategoryAggregate).parents('.category'));
                                            return;
                                        }

                                        $(this).parents('.category').find('.aggregate-value').text(res[0]);
                                        $($prevCategoryAggregate).text(res[1]);
                                    }
                                })
                            }
                        });

                        $category.removeClass('is-loading');
                    }
                },
                complete: function () {
                    $category.removeData('kanban-request');
                }
            });

            $category.data('kanban-request', request);
        }
    }
});